module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "column-sortable",
    class: _vm.sortOrderClass,
    attrs: {
      "title": _vm.data.tooltip
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$emit("toggleOrder", _vm.data.id)
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.data.label)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0064b68e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/ansergy-datatable/table-header-cell.vue
// module id = 252
// module chunks = 1